import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "@/router";
import i18n from "./locales";
import "@/assets/styles/index.css";
import "@/assets/styles/base.css";
import App from "./App.vue";
import VConsole from "vconsole";
import Vant from "vant";
import "vant/lib/index.css"; // 引入 Vant 的全局样式
import '@/assets/fonts/fonts.css' // 引入自定义字体


// 初始化 vConsole
if (process.env.NODE_ENV === "development") {
  // 只在开发环境中引入 VConsole
  const vConsole = new VConsole();
}

createApp(App).use(Vant).use(router).use(i18n).use(createPinia()).mount("#app");
